module.exports = __webpack_public_path__ + "img/selected-me_7f4f1.png";